import Controller from "./views/view";
export default Controller;